<!--<main class="app">-->
  <router-outlet />

  <!--<app-qr-view />-->
 
  <!--<div class="d-none">
    <google-translate />
  </div>-->
<!--</main>-->


<!--<ion-app (click)="increaseClick()">
  @if(tools.showHeader && (tools.isApp || tools.isDistributor || isRegisterMode())){
    <app-header />
  }

  <div [@routeAnimations]="prepareRoute(outlet)" class="route-container">
    <router-outlet [ngClass]="{'animation-open': tools.showMenuDropdown === true, 'animation-close': tools.showMenuDropdown === false}" #outlet="outlet" />
  </div>
  
  @if(chatId && (tools.isApp || tools.isDistributor) && !isCustomRoute() && !isRegsiterUserRoute()){
    <chat-bot-standalone [chatID]="chatId" />
  }

  @if(isAppLoaded() && !isTechMode() && !isRegsiterUserRoute() && !isCustomRoute()){
    <banner-install-cicerone />
  }
</ion-app>-->

<!--@if(tools.showRouteSpinner()){
  <div class="spinner-loader-route">
    <ion-spinner />
  </div>
}-->